<label id="{idText}" class="prom-radio-button {cssClassText}">
    <span class="prom-radio-button__control">
        <input
            type="radio"
            class="prom-radio-button__input | screen-reader"
            disabled="{disabled}"
            {checked}
            name="{name}"
            bind:group={selected}
            value="{value}"
            aria-labelledby="{idText}__label"
            aria-describedby={description ? `${idText}__description` : null}
            on:click={() => dispatch('selected')}
        />
        <span class="prom-radio-button__custom-button">
            <span class="prom-radio-button__custom-button-inner"></span>
        </span>
        <span id="{idText}__label" class="prom-radio-button__label-text">
            {label}
        </span>
    </span>

    {#if description}
        <span id="{idText}__description" class="prom-radio-button__description">
            {description}
        </span>
    {/if}
</label>

<script>
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    export let label = undefined;
    export let id = '';
    export let selected = undefined;
    export let disabled = false;
    export let name = undefined;
    export let value = undefined;
    export let description = undefined;
    export let small = false;

    $: cssClassText = cssClass(selected, value, disabled, small);
    $: checked = value === selected;

    let idText;
    $: {
        if (!id || typeof id !== 'string') {
            console.warn('Id must be supplied');
        } else {
            idText = id;
        }
    }

    $: {
        if (!label || typeof label !== 'string') {
            console.warn('Label must be supplied');
        }
    }

    $: {
        if (value.length) {
            console.warn('Value must be supplied');
        }
    }

    function cssClass(selected, value, disabled, small) {
        let cssClass;
        if (selected === value) {
            cssClass = disabled ? 'selected-locked' : 'selected';
        } else {
            cssClass = disabled ? 'disabled' : '';
        }

        if (small) {
            cssClass += ' prom-radio-button--small';
        }

        return cssClass;
    }
</script>
